import * as uuid from 'uuid';
import moment from 'moment';

import * as api from '../api';

export function mockEhrTimeSlots(
  amount: number = 10,
): api.EhrTimeSlot.EhrTimeSlot[] {
  return Array.from(Array(amount).keys()).map((_, i) => {
    const daysToAdd = Math.floor(i / 3);
    return {
      id: uuid.v4(),
      startTime: moment()
        .add(daysToAdd, 'days')
        .hours(13)
        .add(1, 'hours')
        .set('minute', 0)
        .add((i - daysToAdd) * 30, 'minutes')
        .toDate(),
      endTime: moment()
        .add(daysToAdd, 'days')
        .hours(13)
        .add(1, 'hours')
        .set('minute', 0)
        .add((i - daysToAdd) * 30, 'minutes')
        .add(15, 'minutes')
        .toDate(),
      appointmentKind: 'NOTIONAL',
      practiceId: '12345',
    };
  });
}
